<template>
  <div>
    <base-alert
      :type="messageAlert.type"
      dismissible
      v-if="messageAlert.status"
    >
      <span class="alert-inner--icon"><i :class="messageAlert.icon"></i></span>
      <span class="alert-inner--text" v-if="messageAlert.type == 'danger'">
        <ul>
          <li v-for="(arrayMsg, index) in messageAlert.message" :key="index">
            <strong v-for="(msg, i) in arrayMsg" :key="i">{{ msg }}</strong>
          </li>
        </ul>
      </span>
      <span class="alert-inner--text" v-else>
        <strong>{{ messageAlert.message }}</strong>
      </span>
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </base-alert>
    <modal
      :show.sync="activarModal"
      body-classes="p-12"
      modal-classes="modal-dialog-centered modal-sm"
    >
      <card
        type="default"
        shadow
        header-classes="bg-white pb-12"
        body-classes="px-lg-12 py-lg-12"
        class="border-0"
      >
        <template>
          <div class="text-muted text-center mb-6">
            <small>{{ cambioForm.titulo }}</small>
          </div>
        </template>
        <template>
          <form role="form">
            <base-input
              alternative
              class="mb-3"
              placeholder="Nombre"
              addon-left-icon="ni ni-email-83"
              v-model="form.nombre"
            >
            </base-input>
            <base-input
              alternative
              class="mb-3"
              placeholder="Fecha de inicio"
              addon-left-icon="ni ni-email-83"
              v-model="form.fecha_inicio"
            >
            </base-input>
            <base-switch v-model="form.inscripciones"></base-switch>
           
            <base-input
              alternative
              class="mb-3"
              placeholder="Dirección"
              addon-left-icon="ni ni-email-83"
              v-model="form.ubicacion"
            >
            </base-input>
            <base-input
              alternative
              class="mb-3"
              placeholder="Teléfono"
              addon-left-icon="ni ni-email-83"
              v-model="form.coordinador"
            >
            </base-input>

            <b-form-select
                    v-model="status"
                    :options="options"
                    value-field="status_inscripcion"
                    text-field="status_inscripcion"
                  >
                  </b-form-select>
            
            
            <div class="text-center">
              <base-button
                type="primary"
                class="my-4"
                @click="saveCatedra"
                >{{ cambioForm.nombreBoton }}</base-button
              >
            </div>
          </form>
        </template>
      </card>
    </modal>
  </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
export default {
  components: {
    Modal,
  },
  props: ["catedra", "typeForm", "activarModal", "cambioForm"],
  data: function() {
    return {
      messageAlert: {
        status: false,
        type: null,
        message: {},
        icon: null,
      },
      form: {
        nombre: "",
        fecha_inicio: "",
        incripciones: 0,
        ubicacion: "",
        coordinador: ""
      },
      formDefault: {
        nombre: "",
        fecha_inicio: "",
        incripciones: 0,
        ubicacion: "",
        coordinador: ""
      },
      nombreBoton: "",
      titulo: "",
      options:[]
    };
  },
  computed: {
    cambioForm() {
      let catedra = this.catedra;
      if (this.typeForm != "Crear") {
        this.form = this.catedra;
        return { nombreBoton: "Actualizar", titulo: "Actualizar" };
      } else {
        this.form = this.formDefault;
        return { nombreBoton: "Registrar", titulo: "Registrar" };
      }
    },
  },
  watch: {
    /* typeForm: function(val){
           const formDefault = {nombre:'',cedula:'',correo:'',direccion:'',apellido:'',password:'',telefono:''};
            if (val === 'Crear') {
                this.form = formDefault;
                //this.nombreBoton = 'Registrar';
                this.titulo = 'Registrar nuevo estudiante';
            }else{
                this.form = this.estudiante;
                this.nombreBoton = 'Actualizar';
                this.titulo = 'Editar estudiante';
            }
        },
        activarModal:function(val){
            if (val === false) {
                this.form = this.formDefault;                                
            }
        }*/
  },
  methods: {
    async saveCatedra() {
      //const typeForm = this.typeForm;
      const data = this.form;
      if (this.typeForm === "Crear") {
        var url = "chairs";
        var method = "post";
        var message = "Se creo la catedra correctamente";
      } else {
        var url = "chairs/" + this.catedra.id;
        var method = "put";
        var message = "Se creo la catedra correctamente";
      }
      try {
        await this.$api({
          url: url,
          method: method,
          data: data,
        });
        this.messageConfig("success", "ni ni-like-2", message);
      } catch (e) {
        if (e.response == "422") {
          console.log("422" + " " + e);
        } else {
          if (e.response.status == "422") {
            console.log(e.response.data);
            this.messageConfig(
              "danger",
              "ni ni-fat-remove",
              e.response.data.errors
            );
          } else {
            this.messageConfig(
              "danger",
              "ni ni-fat-remove",
              "Ocurrio un error, por favor contacte con el administrador de sistema."
            );
          }
        }
      }
      this.initForm();
      this.$emit("listarCatedras");
    },
    initForm() {
      this.form = {
        nombre: "",
        fecha_inicio: "",
        incripciones: 0,
        ubicacion: "",
        coordinador: ""
      };
    },
    messageConfig(type, icon, message) {
      this.messageAlert.status = true;
      this.messageAlert.type = type;
      this.messageAlert.message = message;
      this.messageAlert.icon = icon;
      setTimeout(() => {
        this.messageAlert.status = false;
      }, 5000);
    },
  },
};
</script>
